import MoonLight from "../../assets/images/moon.png";
import SunLight from "../../assets/images/day-mode.png";
import { AppTheme } from "../../config/const";
import { useDispatch, useSelector } from "react-redux";
import { updateAppTheme } from "../../redux/app/actions";
import { useEffect } from "react";

const ThemeSelector = () => {
  const dispatch = useDispatch();
  const { appTheme } = useSelector((state) => state.app);

  useEffect(() => {
    if (appTheme === AppTheme.Dark) {
      document.body.classList.remove("light-theme");
    } else {
      document.body.classList.add("light-theme");
    }
  }, [appTheme]);

  const handleThemeChange = () => {
    let newTheme = appTheme === AppTheme.Dark ? AppTheme.Light : AppTheme.Dark;
    dispatch(updateAppTheme(newTheme));
  };

  return (
    <div className="theme-btn">
      <button type="button" className="btn" onClick={handleThemeChange}>
        <img src={SunLight} alt="sun" className="light_theme" />
        <img src={MoonLight} alt="moon" className="dark_theme" />
      </button>
    </div>
  );
};

export default ThemeSelector;
